import { Polling } from 'components/common';
import { STAKE_CONFIG } from 'components/Staking/stakeConfig';
import { useWallet } from 'components/WalletContext';
import { useEffect } from 'react';
import { useState } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import useV1Contracts from './useV1Contracts';

const useApprovalGenesis = () => {
  const { address } = useWallet();
  const queryClient = useQueryClient();

  const [checked, setChecked] = useState<boolean>(false);
  const [refetchInterval, setRefetchInterval] = useState<false | number>(false);
  const [approving, setApproving] = useState<boolean>(false);

  const { approve: approveGenesis, checkApproval, contractsReady } = useV1Contracts();

  const { data: approved } = useQuery(
    ['approval', 'genesis', address],
    async () => {
      const approved = await checkApproval(address!, STAKE_CONFIG.contractAddress);
      setChecked(true);
      return approved;
    },
    {
      enabled: Boolean(address) && contractsReady,
      refetchInterval,
      staleTime: 0,
    }
  );

  async function approve() {
    try {
      setApproving(true);

      if (!approved) {
        await approveGenesis(STAKE_CONFIG.contractAddress, () => {
          queryClient.invalidateQueries('approval');
          setRefetchInterval(Polling.fast);
        });
      }
    } catch (e) {
      setApproving(false);
    }
  }

  useEffect(() => {
    if (refetchInterval && approved) {
      setRefetchInterval(false);
      setApproving(false);
    }
  }, [refetchInterval, approved]);

  return {
    approve,
    approving,
    approved: approved || false,
    checked: checked || false,
  };
};

export default useApprovalGenesis;
